"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spinner = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const rotate360 = (0, styled_components_1.keyframes) `
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`;
exports.Spinner = styled_components_1.default.div `
  animation: ${rotate360} 1s linear infinite;
  transform: translateZ(0);

  z-index: 1001;
  position: absolute;
  bottom: 50%;
  right: 50%;

  border-top: 2px solid #C4C4C4;
  border-right: 2px solid #C4C4C4;
  border-bottom: 2px solid #C4C4C4;
  border-left: 2px solid #FFFFFF;
  border-radius: 50%;
  background: transparent;

  @media only screen and (max-width: 480px) {
    width: 14px;
    height: 14px;
  }

  @media only screen and (min-width: 480px) {
    width: 16px;
    height: 16px;
  }
`;
